import type { IntersectingElement } from '@/pages/Narrative/components/NarrativeIntersectionObserver';

export const elements: IntersectingElement[] = [
  'key-takeaways',
  'catalysts',
  'assumptions',
  'risks',
  'comments',
];
